import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Form from '../../components/Form/Form';
import TextareaField from '../../components/Fields/TextareaField';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from '../../services/data.service';
import { DataResult } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';
import ButtonBar from '../../components/Fields/ButtonBar';
import SaveButton from '../../components/Buttons/SaveButton';

interface MessageCreateModel {
    replyOnMessageId?: number
    subject: string
    body: string
    isDraft: boolean

    recipientUserIds: number[]
}

const SendMessageView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<DataResult<MessageCreateModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<MessageCreateModel>({
        subject: '',
        body: '',
        isDraft: false,
        recipientUserIds: [1, 10]
    });

    function submit() {
        if (formData) {
            DataService
                .create<MessageCreateModel>(`api/v1/messages/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        //navigate to myMessages
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'subject', label: 'Subject', validationRules: [{ type: 'isRequired' }] },
            { name: 'body', label: 'Message', validationRules: [{ type: 'isRequired' }]  },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };


    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    const { isAuthorizedFor } = useAuth();
    if (!isAuthorizedFor(ApplicationFunctions.EditMessage))
        return (<Unauthorized />);

    return (
        <div className='main-content'>
            <Form title='Send message'>
                <Form.Content >
                    <TextboxField {...getFieldProps('subject')} />
                    <TextareaField {...getFieldProps('body')} cols={80} rows={10} />
                </Form.Content>
                <Form.Footer>
                    <ButtonBar offset={3}>
                        <SaveButton  {...getSubmitButtonProps()} text="Send" />
                    </ButtonBar>
                </Form.Footer>
            </Form>
        </div>
    );
}
export default SendMessageView;